'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M8 0l184 0 0 416c0 6.5-.6 12.9-1.9 19l245.3-245.3-113.1-113.1-82.3 82.3 0-22.6 76.6-76.6 5.7-5.7 5.7 5.7 124.5 124.5 5.7 5.7-5.7 5.7-288.5 288.5 0 0c-4.5 4.5-9.5 8.6-14.8 12.1l346.9 0 0-160-117.1 0 16-16 117.1 0 0 192-416 0c-53 0-96-43-96-96L0 0 8 0zM96 496c44.2 0 80-35.8 80-80l0-400-160 0 0 400c0 44.2 35.8 80 80 80zM48 48l96 0 0 96-96 0 0-96zM80 64l-16 0 0 64 64 0 0-64-48 0zM64 176l80 0 0 96-96 0 0-96 16 0zm0 16l0 64 64 0 0-64-64 0zM96 400a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;